import { Component, OnInit, Input, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { FeeService } from '@app/services/fees/fee.service';
import { Validators, FormBuilder } from '@angular/forms';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import { Subscription } from 'rxjs';

interface Payment {
  isFullyPaid: boolean;
  paidDate: string;
  paidAmount: number;
  totalPaidAmount: number;
  totalAmountToPay: number;
  payPercentage: number;
}

interface MemberPayments {
  memberId: number;
  givenName: string;
  familyName: string;
  payments: Payment[];
}

interface LodgeAndCamp {
  id: number;
  shortName: string;
  name: string;
}

interface NewPayment {
  memberId: number;
  institutionId: number;
  paidAmount: number;
  paidDate: string;
  action: string;
}

@Component({
  selector: 'app-registerpaymentsmulti',
  templateUrl: './registerpaymentsmulti.component.html'
})
export class RegisterpaymentsmultiComponent implements OnInit, OnChanges, OnDestroy {
  @Input() institution: LodgeAndCamp;
  @Input() year: number;
  memberpayments: MemberPayments[] = [];
  feeform;
  

  minmaxyear = { minYear: '1920', maxYear: '2030' };
  autoCorrectedDatePipe = createAutoCorrectedDatePipe('yyyy-mm-dd', this.minmaxyear);
  public mask = [/[1-9]/, /\d/, /\d/, ' ', /\d/, /\d/]; // zipcode
  public maskdatum = [/[129]/, /[?09]/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];

  subscriptions: Subscription[] = [];
  newpayments: NewPayment[] = [];

  constructor(
    private feeService: FeeService,
    private fb: FormBuilder) { }

  ngOnInit() {
    this.feeform = this.fb.group({
      registerDate: ['', Validators.required],
      amount: ['', Validators.required]
    });
    
    this.subscriptions.push(this.feeService.getPaidFees(this.institution.id, this.year).subscribe(response => {
      if (response) {
        this.getNotFullyPaidMembers(response);
      }
    }));
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => {
      sub.unsubscribe();
    });
  }

  getNotFullyPaidMembers(response: any) {
    this.memberpayments = response.filter((data:any) => {
      
      if (data.payments.filter((x:any) => {
        if (!x.isFullyPaid) {
          return x;
        }
      }).length > 0) {
        return data;
      }
    });
  }

  viewMemberId(evt: any) {
    if (evt.source.checked) {
      const payment = {
        memberId: evt.source.id,
        institutionId: this.institution.id,
        paidAmount: this.feeform.get('amount').value,
        paidDate: this.feeform.get('registerDate').value,
        action: 'add'
      };
      this.newpayments.push(payment as any);
    } else {
      this.removeFromArray(evt.source.id);
    }
  }

  removeFromArray(memberid: number) {
    this.newpayments = this.newpayments.filter(item => item.memberId !== memberid);
  }

  addMemberToList(memberid: number) {
    console.log('Lägg till ', memberid);
  }

  ngOnChanges(changes: SimpleChanges) {
    this.ngOnInit();
  }

  registerPayments() {
    this.subscriptions.push(this.feeService.addPaidFee(this.newpayments).subscribe(resp => {
      this.ngOnInit();
    }));
    this.newpayments = [];
    this.feeform.reset();
  }
}
